;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:zestlife-web":true});}catch(e){}}();import SvgIcon from "@mui/material/SvgIcon"
import svg from "../assets/dashedLine.svg"

function DashedLineIcon() {
  return (
    <SvgIcon
      component={svg}
      viewBox="0 0 2 282"
      sx={{
        width: "2px",
        height: "282px",
      }}
    />
  )
}
export default DashedLineIcon
